(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["print-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.print-hero__cta').forEach(function (cta) {
    cta.addEventListener('click', function (event) {
      event.preventDefault();
      var hero = cta.closest('.print-hero');
      var wrapper = hero ? hero.closest('.shopify-section') : null;
      var target = wrapper ? wrapper.nextElementSibling : null;
      if (target) {
        var top = target.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
